import { render, staticRenderFns } from "./FieldsetBirthdayParts.vue?vue&type=template&id=22a8e10a&scoped=true"
import script from "./FieldsetBirthdayParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetBirthdayParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetBirthdayParts.vue?vue&type=style&index=0&id=22a8e10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8e10a",
  null
  
)

export default component.exports